export default __webpack_public_path__ + "static/media/renovation.2c667e01.png";